// German (de)
export default {
  // --- Shell / nav ---
  app_name: 'Gezeiten in der Nähe',
  search_stations: 'Stationen suchen',
  search_stations_hint: 'Stationen suchen (⌘K)',
  settings: 'Einstellungen',
  app_store: 'Laden im App Store',
  google_play: 'Jetzt bei Google Play',
  app_promo_title: 'Hol dir die kostenlose App. Sie ist schneller 🙂',
  app_promo_body: 'Dieselben Gezeiten- und Strömungsvorhersagen, auf deinem Handy.',
  privacy: 'Datenschutz',
  terms: 'Nutzungsbedingungen',
  data_sources: 'Datenquellen',
  support: 'Support',

  guides: 'Ratgeber',
  // --- Home ---
  home_title: 'Gezeiten und Strömungen in der Nähe finden',
  by_country: 'Nach Land',
  favorite_tides: 'Lieblingsgezeiten',
  recent_tides: 'Neuste Gezeiten',
  nearby_tides: 'Gezeiten in der Nähe',
  favorite_currents: 'Lieblingsströme',
  recent_currents: 'Neuste Meeresströmungen',
  nearby_currents: 'Meeresströmungen in der Nähe',
  favorite_charts: 'Lieblingsseekarten',
  recent_charts: 'Neuste Seekarten',
  nearby_charts: 'Seekarten in der Nähe',
  finding_stations: 'Stationen in Ihrer Nähe werden gesucht…',
  distance_away: '{{distance}} entfernt',

  // --- Search overlay ---
  search_placeholder: 'Stationen suchen…',
  tide_stations: 'Gezeitenstationen',
  current_stations: 'Strömungsstationen',
  recents: 'Letzte',
  search_unavailable: 'Die Suche ist derzeit nicht verfügbar.',
  no_stations_found: 'Keine Stationen gefunden.',
  search_prompt: 'Gezeiten- & Strömungsstationen nach Namen suchen.',

  // --- Settings ---
  appearance: 'Erscheinungsbild',
  appearance_system: 'System',
  appearance_light: 'Hell',
  appearance_dark: 'Dunkel',
  tide_height: 'Gezeitenhöhe',
  unit_feet: 'Fuß',
  unit_meters: 'Meter',
  distance: 'Entfernung',
  unit_miles: 'Meilen',
  unit_kilometers: 'Kilometer',
  recent_stations: 'Neuste Stationen',
  clear_recents: 'Letzte löschen',
  currents: 'Meeresströmungen',
  nautical_charts: 'Seekarten',
  browse_by_country: 'Nach Land durchsuchen',
  countries_auto: 'Automatisch',
  countries_always: 'Immer',
  countries_never: 'Nie',
  show: 'Anzeigen',
  hide: 'Verbergen',

  // --- Station pages (tide + current) ---
  tide_title: '{{name}} Gezeiten',
  current_title: '{{name}} Strömungen',
  last_tide: 'Letzte Gezeit',
  next_tide: 'Nächste Gezeit',
  coefficient: 'Coef',
  last_current: 'Letzte Meeresströmung',
  next_current: 'Nächste Meeresströmung',
  following_current: 'Darauf folgende Meeresströmung',
  high: 'Hoch',
  low: 'Tief',
  tides: 'Gezeiten',
  sun: 'Sonne',
  moon: 'Mond',
  sunrise_now: 'Sonnenaufgang',
  sunset_now: 'Sonnenuntergang',
  moonrise_now: 'Mondaufgang',
  moonset_now: 'Monduntergang',
  sunrise_week: 'Aufgang',
  sunset_week: 'Untergang',
  moonrise_week: 'Aufgang',
  moonset_week: 'Untergang',
  add_to_favorites: 'Zu Favoriten hinzufügen',
  remove_from_favorites: 'Aus Favoriten entfernen',

  // --- Week table dates ---
  today: 'Heute',
  tomorrow: 'Morgen',

  // --- Moon phases ---
  phase_new_moon: 'Neumond',
  phase_waxing_crescent: 'Zunehmende Sichel',
  phase_first_quarter: 'Erstes Viertel',
  phase_waxing_gibbous: 'Zunehmender Mond',
  phase_full_moon: 'Vollmond',
  phase_waning_gibbous: 'Abnehmender Mond',
  phase_last_quarter: 'Letztes Viertel',
  phase_waning_crescent: 'Abnehmende Sichel',

  // --- Tide / current status vocabulary ---
  rising: 'Steigend',
  falling: 'Fallend',
  high_tide: 'Hochwasser',
  low_tide: 'Niedrigwasser',
  ebb: 'Ebbe',
  flood: 'Flut',
  slack: 'Stauwasser',

  // --- Relative time (separate singular/plural keys, native-style) ---
  just_now: 'Gerade eben',
  somethings_wrong: 'Es ist ein Fehler aufgetreten',
  hour_ago: 'vor {{hour}} Stunde',
  hours_ago: 'vor {{hour}} Stunden',
  minute_ago: 'vor {{minute}} Minute',
  minutes_ago: 'vor {{minute}} Minuten',
  hour_minute_ago: 'vor {{hour}} Stunde und {{minute}} Minute',
  hour_minutes_ago: 'vor {{hour}} Stunde und {{minute}} Minuten',
  hours_minute_ago: 'vor {{hour}} Stunden und {{minute}} Minute',
  hours_minutes_ago: 'vor {{hour}} Stunden und {{minute}} Minuten',
  hour_from_now: 'in {{hour}} Stunde ab jetzt',
  hours_from_now: 'in {{hour}} Stunden ab jetzt',
  minute_from_now: 'in {{minute}} Minute ab jetzt',
  minutes_from_now: 'in {{minute}} Minuten ab jetzt',
  hour_minute_from_now: 'in {{hour}} Stunde und {{minute}} Minute ab jetzt',
  hour_minutes_from_now: 'in {{hour}} Stunde und {{minute}} Minuten ab jetzt',
  hours_minute_from_now: 'in {{hour}} Stunden und {{minute}} Minute ab jetzt',
  hours_minutes_from_now: 'in {{hour}} Stunden und {{minute}} Minuten ab jetzt',

  // --- Insights ---
  insights_7_day_overview: '7-Tage-Einblicke',
  no_insights_available: 'Keine Einblicke für diese Station verfügbar.',
  insights_current_extremes: 'Strömungsextreme',
  insights_fastest_flood: 'Schnellste Flut',
  insights_fastest_ebb: 'Schnellste Ebbe',
  insights_strongest_daily_currents: 'Tägliche Spitzenströmungen',
  insights_fastest_current: 'Schnellste',
  insights_slowest_current: 'Langsamste',
  insights_tidal_extremes: 'Gezeitenextreme',
  insights_highest_tide: 'Höchstes Hochwasser',
  insights_lowest_tide: 'Niedrigstes Niedrigwasser',
  insights_strongest_daily_movements: 'Größte Gezeitenbereiche',
  insights_largest_tide: 'Größter',
  insights_smallest_tide: 'Kleinster',
  insights_value_at_time: '{{value}} um {{time}}',
  insights_tidal_range_label: 'Tidenhub',
  insights_max_current_label: 'Max.-Strömung',

  // --- Insight bands ---
  band_smaller_than_usual: 'Kleiner als üblich',
  band_typical: 'Typisch',
  band_larger_than_usual: 'Größer als üblich',
  band_unusually_large: 'Ungewöhnlich groß',
  band_lower_than_usual: 'Niedriger als üblich',
  band_unusually_low: 'Ungewöhnlich niedrig',
  band_slower_than_usual: 'Langsamer als üblich',
  band_faster_than_usual: 'Schneller als üblich',
  band_unusually_fast: 'Ungewöhnlich schnell',
  band_smaller_than_usual_height: 'Niedriger als üblich',
  band_larger_than_usual_height: 'Höher als üblich',
  band_unusually_large_height: 'Ungewöhnlich hoch',

  // --- Map attribution ---
  attribution: 'Namensnennung',
  attribution_osm: 'Kartendaten © OpenStreetMap-Mitwirkende',
  attribution_tiles: 'Kartenkacheln von OpenFreeMap',
  attribution_style: 'Kartenstil © OpenMapTiles',
  ok: 'OK',

  // --- Explore map ---
  current_speed: 'Strömungsgeschwindigkeit',
  depth: 'Tiefe',
  speed: 'Geschwindigkeit',
  depth_datum: 'Tiefen ab',
  depth_drying: 'Trockenfallend',
  depth_loading: 'Tiefendaten werden geladen…',
  depth_datum_tag: 'Tiefen in {{unit}} unter {{datum}}',
  depth_not_for_navigation: 'Nicht für die Navigation.',
  depth_unavailable: 'Tiefendaten sind derzeit nicht verfügbar.',
  depth_unit_m: 'm',
  depth_unit_ft: 'ft',
  go_mode_start: 'GO',
  go_mode_start_label: 'Go-Modus starten',
  go_mode_exit: 'Go-Modus beenden',
  go_mode_location_denied:
    'Der Go-Modus benötigt Ihren Standort. Aktivieren Sie ihn über das Schloss-Symbol.',
  go_mode_location_denied_ok: 'OK',
  radar: 'Radar',
  radar_precipitation: 'Niederschlag',
  radar_light: 'leicht',
  radar_moderate: 'mäßig',
  radar_heavy: 'stark',
  radar_storm: 'sehr stark',
  radar_forecast: 'Vorhersage',
  radar_none_for_time: 'kein Radar für diesen Zeitpunkt',
  now: 'Jetzt',
  explore_prompt_denied:
    'Der Standortzugriff ist für diese Seite deaktiviert - aktivieren Sie ihn über das Schloss-Symbol in der Adressleiste.',
  open_full_map: 'Vollständige Karte öffnen',
  close_full_map: 'Vollständige Karte schließen',
  explore_full_map: 'Vollständige Karte erkunden',
  center_on_location: 'Auf meinen Standort zentrieren',
  show_my_location: 'Meinen Standort anzeigen',
  map_knots_label: '{{speed}} kt',

  // --- Location pages ---
  states: 'Regionen',
  no_stations_found_location: 'Keine Stationen gefunden.',
  tides_and_currents_by_country: 'Gezeiten & Strömungen nach Land',

  // --- SEO titles / descriptions ---
  settings_seo_description: 'Wählen Sie Ihre Einheiten für Gezeitenhöhen und Entfernungen.',
  tide_seo_description:
    'Gezeitenvorhersagen, Hoch- und Niedrigwasserzeiten für {{name}}{{location}}.',
  current_seo_description:
    'Vorhersagen der Gezeitenströmungen, Flut- und Ebbezeiten für {{name}}{{location}}.',
  location_title: '{{name}} Gezeiten & Strömungen',
  country_seo_description:
    'Gezeitenzeiten und Vorhersagen der Gezeitenströmungen für {{name}}. Durchsuchen Sie {{stateTerm}} und Küstengezeitenstationen in {{name}}.',
  state_seo_description:
    'Gezeiten- und Strömungsvorhersagen für {{name}}, {{country}}. Hoch- und Niedrigwasserzeiten für Küstenstationen in {{name}}.',
  city_seo_description:
    'Gezeitenzeiten und Vorhersagen der Gezeitenströmungen für {{place}}. Hoch- und Niedrigwasser und Strömungen in der Nähe von {{name}}.',
  // --- Chart pages (chart titles, numbers and purposes stay in the
  // issuing authority's language: they name a specific printed sheet) ---
  charts_for_station: 'Seekarten für {{name}}',
  chart_intro:
    'Kostenlose Seekarte von {{title}}: kartierte Wassertiefen, Bojen, Baken, Felsen, Wracks, Marinas, Ankerplätze und Gezeitenstationen.',
  chart_page_name: '{{title}} Seekarte',
  chart_seo_description:
    'Kostenlose Seekarte von {{title}}: kartierte Wassertiefen, Bojen, Baken, Felsen, Wracks, Marinas, Ankerplätze und Gezeitenstationen.',

  countries_seo_title: 'Gezeiten- & Strömungsstationen nach Land',
  countries_seo_description:
    'Durchsuchen Sie Gezeiten- und Strömungsstationen nach Land. Hoch- und Niedrigwasserzeiten und Vorhersagen der Gezeitenströmungen für Küstenorte weltweit.',
  home_seo_description:
    'Finden Sie Gezeitenzeiten und Vorhersagen der Gezeitenströmungen für Küstenstationen in Ihrer Nähe. Sehen Sie Hoch- und Niedrigwasser für Ihren Standort oder durchsuchen Sie Stationen nach Land.',
  explore_play: 'Abspielen',
  explore_pause: 'Pause',
  explore_playback_speed: 'Wiedergabegeschwindigkeit',
  explore_time: 'Zeit',
  skip_to_content: 'Zum Hauptinhalt springen',
  // --- Weather (station pages) ---
  weather: 'Seewetter',
  wind: 'Wind',
  gusts: 'Böen',
  seas: 'Seegang',
  time: 'Zeit',
  air_temp: 'Luft',
  water_temp: 'Wasser',
  water_temperature: 'Wassertemperatur',
  humidity: 'Luftfeuchte',
  pressure: 'Luftdruck',
  precip_chance: 'Niederschlag',
  chances: 'Risiko',
  precip_rate: 'Niederschlagsrate',
  visibility: 'Sicht',
  condition_thunderstorms: 'Gewitter',
  condition_freezing_rain: 'Gefrierender Regen',
  condition_sleet: 'Schneeregen',
  condition_snow: 'Schnee',
  condition_fog: 'Nebel',
  condition_rain: 'Regen',
  condition_cloudy: 'Bewölkt',
  condition_partly_cloudy: 'Teilweise bewölkt',
  condition_clear: 'Klar',
  weather_thunder: 'Gewitter',
  note_seas_computed_from_wind: 'Wellenhöhen werden aus Wind und Küstenlinie geschätzt.',
  note_seas_from_nearby_open_water: 'Der Seegang stammt aus nahegelegenem offenem Wasser.',
  note_seas_open_water_nearby:
    'Die Wellen auf dem offenen Wasser in der Nähe liegen bei etwa {{height}}. Hier kann es ruhiger sein.',
  note_seas_open_water_distant:
    'Die Wellen auf dem offenen Wasser in {{distance}} Entfernung liegen bei etwa {{height}}. Hier kann es ruhiger sein.',
  note_seas_open_water_distant_dir:
    'Die Wellen auf dem offenen Wasser {{distance}} {{direction}} von hier liegen bei etwa {{height}}. Hier kann es ruhiger sein.',
  note_seas_unavailable: 'Für diesen Punkt ist kein verlässlicher Seegang verfügbar.',
  note_sheltered_water_sees_less:
    'In geschützten Gewässern fällt der Seegang meist geringer aus als diese Werte für offenes Wasser.',
  note_no_warning_feed_coverage: 'Kein offizieller Seewetter-Warndienst deckt diesen Punkt ab.',
  note_nearest_point_across_land: 'Der nächstgelegene Vorhersagepunkt liegt hinter Land.',
  warnings_none_active: 'Keine Seewetterwarnungen in Kraft',
  warnings_unavailable: 'Für diesen Ort sind keine Seewetterwarnungen verfügbar',
  warning_show_text: 'Offiziellen Text anzeigen',
  warning_hide_text: 'Offiziellen Text ausblenden',
  weather_updated: 'Aktualisiert {{time}}',
  current_conditions: 'Aktuelle Bedingungen',
  daily_forecast: 'Tagesvorhersage',
  expand_for_hourly: 'Für Stundenwerte aufklappen',
  hourly: 'Stündlich',
  hourly_forecast: 'Stundenvorhersage',
  wind_speed: 'Windgeschwindigkeit',
  wind_gusts: 'Wind & Böen',
  pressure_humidity: 'Luftdruck & Luftfeuchte',
  max_seas: 'Max. Seegang',
  visibility_excellent: 'Ausgezeichnet',
  visibility_good: 'Gut',
  visibility_moderate: 'Mäßig',
  visibility_poor: 'Schlecht',
  forecaster_text_link: '{{issuer}}-Vorhersagetext',
  temperature: 'Temperatur',
  unit_fahrenheit: 'Fahrenheit',
  unit_celsius: 'Celsius',
  // --- Conditions summary (station pages) ---
  // Sea state: WMO Sea State Code. Wind: Beaufort. Both are published
  // scales with standard terminology in each language, not our own wording.
  // Warning-window and low–high range punctuation. CJK marks a range (and
  // an open end) with ～, not an en dash or a trailing plus.
  warning_window_range: '{{start}} – {{end}}',
  warning_window_open: '{{start}}+',
  range_separator_short: '-',
  // Wave-period fragments. The connector is the locale's own word for the
  // "at" in "0.5 m S @ 3s" (CJK says "period" instead); the value carries
  // the locale's seconds notation (秒/초 — bare Latin "s" reads as an
  // untranslated fragment in CJK weather products).
  seas_period_at: 'bei',
  wave_period_short: '{{period}}s',
  // 16-point compass, per this locale’s meteorological convention — the
  // letters differ across languages (Z/O/Ø/V…) and CJK writes the words out.
  compass_N: 'N',
  compass_NNE: 'NNO',
  compass_NE: 'NO',
  compass_ENE: 'ONO',
  compass_E: 'O',
  compass_ESE: 'OSO',
  compass_SE: 'SO',
  compass_SSE: 'SSO',
  compass_S: 'S',
  compass_SSW: 'SSW',
  compass_SW: 'SW',
  compass_WSW: 'WSW',
  compass_W: 'W',
  compass_WNW: 'WNW',
  compass_NW: 'NW',
  compass_NNW: 'NNW',
  // Known warning types, one badge label each. Bureau-home locales use the
  // bureau’s official terminology. Unknown types fall back to the humanized
  // English code in every locale (see warningTypeLabel).
  warning_type_small_craft_advisory: 'Warnung für kleine Boote',
  warning_type_gale_warning: 'Sturmwarnung',
  warning_type_gale_watch: 'Sturmvorwarnung',
  warning_type_storm_warning: 'Schwere Sturmwarnung',
  warning_type_storm_watch: 'Schwere Sturmvorwarnung',
  warning_type_hurricane_force_wind_warning: 'Orkanwarnung',
  warning_type_hurricane_force_wind_watch: 'Orkanvorwarnung',
  warning_type_special_marine_warning: 'Spezielle Seewetterwarnung',
  warning_type_marine_weather_statement: 'Seewetterhinweis',
  warning_type_hazardous_seas_warning: 'Warnung vor gefährlichem Seegang',
  warning_type_brisk_wind_advisory: 'Hinweis auf frischen Wind',
  warning_type_low_water_advisory: 'Niedrigwasserhinweis',
  warning_type_dense_fog_advisory: 'Hinweis auf dichten Nebel',
  warning_type_heavy_freezing_spray_warning: 'Warnung vor starker Vereisung',
  warning_type_strong_wind_warning: 'Starkwindwarnung',
  warning_type_gale_force_wind_warning: 'Sturmwarnung',
  warning_type_storm_force_wind_warning: 'Schwere Sturmwarnung',
  warning_type_wind_warning: 'Windwarnung',
  warning_type_dense_fog_warning: 'Warnung vor dichtem Nebel',
  warning_type_icing_warning: 'Vereisungswarnung',
  warning_type_typhoon_warning: 'Taifunwarnung',
  warning_type_wind_wave_warning: 'Seegangswarnung',
  warning_type_wind_wave_advisory: 'Seegangshinweis',
  warning_type_strong_wind_advisory: 'Starkwindhinweis',
  warning_type_storm_surge_warning: 'Sturmflutwarnung',
  warning_type_storm_surge_advisory: 'Sturmfluthinweis',
  warning_type_thunderstorm_warning: 'Gewitterwarnung',
  warning_type_rough_sea_warning: 'Warnung vor rauer See',
  warning_type_fog_warning: 'Nebelwarnung',
  sea_state_calm_rippled: 'Gekräuselte See',
  sea_state_smooth: 'Ruhige See',
  sea_state_slight: 'Leichte See',
  sea_state_moderate: 'Mäßige See',
  sea_state_rough: 'Grobe See',
  sea_state_very_rough: 'Sehr grobe See',
  sea_state_high: 'Hohe See',
  sea_state_very_high: 'Sehr hohe See',
  sea_state_phenomenal: 'Außergewöhnliche See',
  hazard_showers: 'Schauer',
  hazard_reduced_visibility: 'Eingeschränkte Sicht',
  hazard_haze: 'Dunst',
  hazard_waterspout: 'Wasserhosen',
  hazard_freezing_spray: 'Vereisungsgischt',
  hazard_ice: 'Eis',
  marine_summary_sea_wind: '{{sea}}, {{direction}}-Wind mit {{speed}}.',
  marine_summary_wind_only_gusting: '{{direction}}-Wind mit {{speed}}, in Böen {{gust}}.',
  marine_summary_sea_wind_gusting: '{{sea}}, {{direction}}-Wind mit {{speed}}, in Böen {{gust}}.',
  marine_summary_wind_only: '{{direction}}-Wind mit {{speed}}.',
  marine_summary_sea_only: '{{sea}}.',
  marine_prediction_caveat_tide_one:
    'Gezeitenvorhersagen sind rein astronomisch, daher kann das Wetter in dieser Warnung den tatsächlichen Wasserstand heben oder senken.',
  marine_prediction_caveat_tide_many:
    'Gezeitenvorhersagen sind rein astronomisch, daher kann das Wetter in diesen Warnungen den tatsächlichen Wasserstand heben oder senken.',
  marine_prediction_caveat_current_one:
    'Stromvorhersagen sind rein astronomisch, daher kann das Wetter in dieser Warnung den tatsächlichen Strom verstärken oder abschwächen.',
  marine_prediction_caveat_current_many:
    'Stromvorhersagen sind rein astronomisch, daher kann das Wetter in diesen Warnungen den tatsächlichen Strom verstärken oder abschwächen.',
  marine_warning_active: 'Für dieses Gebiet gilt eine Seewetterwarnung.',
  marine_warnings_active: 'Für dieses Gebiet gelten Seewetterwarnungen.',
  marine_warning_upcoming: 'Für dieses Gebiet gilt eine Seewetterwarnung ab {{time}}.',
  marine_warnings_upcoming: 'Für dieses Gebiet gelten Seewetterwarnungen ab {{time}}.',
  marine_summary_hazard_now: 'Aktuell: {{hazard}}.',
  marine_summary_hazard_later: 'Vorhergesagt: {{hazard}}.',
  marine_tide_rising:
    'Das Wasser steht bei {{height}} und steigt: nächstes Hochwasser {{next}} um {{time}}.',
  marine_tide_falling:
    'Das Wasser steht bei {{height}} und fällt: nächstes Niedrigwasser {{next}} um {{time}}.',
  marine_current_flood: 'Nächster Flutstrom {{speed}} um {{time}}.',
  marine_current_ebb: 'Nächster Ebbstrom {{speed}} um {{time}}.',
  marine_current_slack: 'Nächstes Stauwasser um {{time}}.',
  marine_current_now_flood: 'Der Strom läuft auf mit {{speed}}.',
  marine_current_now_ebb: 'Der Strom läuft ab mit {{speed}}.',
  marine_current_now_slack: 'Stauwasser.',
  marine_current_peak: 'Maximum {{speed}} um {{time}}.',

  // --- Chart furniture (navaid / hazard / POI click popups) ---
  // See en.js for the rules these follow. "IALA A" / "IALA B" stay untranslated
  // in every language: it is the standard's name.
  furn_light: 'Feuer',
  furn_buoy: 'Tonne',
  furn_beacon: 'Bake',
  furn_wreck: 'Wrack',
  furn_rock: 'Klippe',
  furn_obstruction: 'Hindernis',
  furn_anchorage: 'Ankerplatz',
  furn_tss: 'Verkehrstrennungsgebiet',
  furn_routing: 'Verkehrsführung',
  furn_title_buoy: '{{category}} Tonne',
  furn_title_beacon: '{{category}} Bake',
  furn_cat_port: 'Backbord',
  furn_cat_starboard: 'Steuerbord',
  furn_cat_preferred_channel_port: 'Bevorzugtes Fahrwasser backbord',
  furn_cat_preferred_channel_starboard: 'Bevorzugtes Fahrwasser steuerbord',
  furn_cat_safe_water: 'Mittefahrwasser',
  furn_cat_isolated_danger: 'Einzelgefahren',
  furn_cat_north: 'Nord',
  furn_cat_east: 'Ost',
  furn_cat_south: 'Süd',
  furn_cat_west: 'West',
  furn_cat_special: 'Sonder',
  furn_cat_mooring: 'Festmache',
  furn_cat_lateral: 'Lateral',
  furn_characteristic: 'Kennung',
  furn_range: 'Tragweite',
  furn_height: 'Höhe',
  furn_colour: 'Farbe',
  furn_shape: 'Form',
  furn_lights_on_mark: 'Lichter an diesem Seezeichen',
  furn_topmark: 'Toppzeichen',
  furn_class: 'Klasse',
  furn_least_depth_over: 'Geringste Tiefe darüber',
  furn_depth_over: 'Tiefe darüber',
  furn_state: 'Zustand',
  furn_type: 'Art',
  furn_range_value: '{{value}} M',
  furn_metres_value: '{{value}} m',
  furn_cable: 'Seekabel',
  furn_pipeline: 'Rohrleitung',
  furn_restricted_area: 'Sperrgebiet',
  furn_restriction: 'Beschränkung',
  furn_mpa: 'Meeresschutzgebiet',
  furn_protection: 'Schutz',
  furn_agency: 'Verwaltet von',
  furn_mpa_note: 'Eine Naturschutzausweisung, keine Navigationsbeschränkung.',
  furn_sector: 'Sektor',
  furn_sector_value: '{{from}}° → {{to}}°',
  lightw_f: 'Festes {{colour}}es Licht.',
  lightw_fl: 'Blitzt {{colour}} alle {{period}} Sekunden.',
  lightw_fl_group: 'Blitzt {{colour}} in Gruppen von {{count}}, alle {{period}} Sekunden.',
  lightw_lfl: 'Ein langer {{colour}}er Blitz alle {{period}} Sekunden.',
  lightw_q: 'Schnelles {{colour}}es Funkeln.',
  lightw_iso: 'Gleich lange {{colour}}e Hell- und Dunkelphasen, alle {{period}} Sekunden.',
  lightw_oc: 'Unterbrochenes {{colour}}es Licht alle {{period}} Sekunden.',
  lightcolour_white: 'weiß',
  lightcolour_red: 'rot',
  lightcolour_green: 'grün',
  lightcolour_yellow: 'gelb',
  furn_feet_charted_value: '{{feet}} ft ({{metres}} m laut Karte)',
  furn_light_yes: 'ja',
  furn_shown_neutral: '{{colours}} (neutral dargestellt)',
  furn_note_light: 'So erscheint das Licht bei Nacht: daran erkennt es der Seefahrer.',
  furn_note_lateral_b_port:
    'Markiert die LINKE Seite der Fahrrinne bei der Einfahrt von See (IALA B: grüne Stumpftonne).',
  furn_note_lateral_b_starboard:
    'Markiert die RECHTE Seite der Fahrrinne bei der Einfahrt von See (IALA B: „rot rechts bei der Einfahrt“).',
  furn_note_lateral_a_port:
    'Markiert die BACKBORD-Seite der Fahrrinne bei der Einfahrt von See (IALA A: rot an Backbord).',
  furn_note_lateral_a_starboard:
    'Markiert die STEUERBORD-Seite der Fahrrinne bei der Einfahrt von See (IALA A: grün an Steuerbord).',
  furn_note_safe_water:
    'Ringsum sicheres Fahrwasser, meist die Ansteuerungs- oder Mittefahrwassertonne.',
  furn_note_isolated_danger:
    'Liegt über einer einzelnen Gefahrenstelle mit befahrbarem Wasser ringsum.',
  furn_note_cardinal_north: 'Kardinalzeichen: NÖRDLICH daran vorbeifahren.',
  furn_note_cardinal_east: 'Kardinalzeichen: ÖSTLICH daran vorbeifahren.',
  furn_note_cardinal_south: 'Kardinalzeichen: SÜDLICH daran vorbeifahren.',
  furn_note_cardinal_west: 'Kardinalzeichen: WESTLICH daran vorbeifahren.',
  furn_note_special: 'Sonderzeichen (gelb): Grenzen, Kabel, Liegeplätze, Regatten.',
  furn_note_preferred_starboard:
    'Bifurkationszeichen: Das bevorzugte Fahrwasser liegt an Steuerbord.',
  furn_note_preferred_port: 'Bifurkationszeichen: Das bevorzugte Fahrwasser liegt an Backbord.',
  furn_note_mooring: 'Festmachetonne.',
  furn_vessel: 'Schiff',
  furn_depth_quality: 'Tiefenqualität',
  furn_length: 'Länge',
  furn_position_accuracy: 'Positionsgenauigkeit',
  furn_remarks: 'Bemerkungen',
  furn_circumstances: 'Umstände',
  furn_status: 'Status',
  furn_note_shom: 'Kartiert vom Shom (Frankreich). ©Shom, CC BY-SA 4.0.',
  furn_lock: 'Schleuse',
  furn_bridge: 'Brücke',
  furn_overhead_cable: 'Freileitung',
  furn_notice_mark: 'Hinweistafel',
  furn_distance_mark: 'Kilometermarke',
  furn_daymark: 'Tagesmarke',
  furn_channel: 'Fahrrinne',
  furn_vertical_clearance_closed: 'Durchfahrtshöhe (geschlossen)',
  furn_vertical_clearance_open: 'Durchfahrtshöhe (geöffnet)',
  furn_datum: 'Bezugsniveau',
  furn_datum_value: '{plane} (VERDAT {code})',
  furn_datum_unknown: 'unknown code (VERDAT {code})',
  furn_note_ienc:
    'Binnen-ENC (US Army Corps of Engineers). Durchfahrtshöhen gelten über dem oben genannten Bezugsniveau; bei Hochwasser ist die tatsächliche Höhe geringer.',
  furn_note_wreck: 'Verzeichnetes Wrack. Tiefen sind Kartenwerte, nicht überprüft.',
  furn_note_anchorage: 'Verzeichneter Ankerplatz.',
  furn_note_tss:
    'Einbahn-Schifffahrtswege. Kleine Fahrzeuge queren rechtwinklig und halten sich frei.',
  furn_route: 'Route',
  furn_fairway: 'Fahrwasser',
  furn_recommended_track: 'Empfohlener Kurs',
  furn_navigation_line: 'Navigationslinie',
  furn_leading_line: 'Richtfeuerlinie',
  furn_clearing_line: 'Freifahrtlinie',
  furn_transit_line: 'Transitlinie',
  furn_traffic: 'Verkehr',
  furn_orientation: 'Orientierung',
  furn_degrees_value: '{{value}}°',
  furn_note_fairway:
    'In der Karte verzeichnetes Fahrwasser: die unterhaltene oder bevorzugte Rinne.',
  furn_note_track: 'In der Karte verzeichnete Kurslinie.',
  furn_note_track_fixed_marks:
    'In der Karte verzeichnete Kurslinie, nach festen Marken (Deckpeilungen).',
  furn_note_leading_line:
    'Halten Sie die Richtmarken in Deckung, um auf der verzeichneten Linie zu bleiben.',
  furn_note_navigation_line: 'In der Karte verzeichnete Navigationslinie.',
  furn_poi_marina: 'Marina',
  furn_poi_fuel: 'Kraftstoff',
  furn_poi_slipway: 'Slipanlage',
  furn_poi_ferry_terminal: 'Fährterminal',
  furn_poi_boatyard: 'Bootswerft',
  furn_poi_lighthouse: 'Leuchtturm',
  furn_note_slipway: 'Slipanlage.',
  // Layers sheet — UNTRANSLATED, English placeholders (2026-09-11). Catalog
  // parity is enforced by scripts/check-locale-keys.mjs, so a key cannot be
  // added to en.js alone; these are placeholders awaiting translation, not
  // a claim that the strings are localized.
  layers: 'Layers',
  layers_close: 'Close layers',
  layers_map_type: 'Map type',
  layers_visualizations: 'Visualizations',
  layers_standard_map: 'Standard Map',
  layers_depth_chart: 'Depth Chart',
  layers_moving_tides: 'Moving Tides',
  layers_moving_currents: 'Moving Currents',
  layers_wind_waves: 'Wind & Waves',
  layers_weather_radar: 'Weather Radar',
  layers_coming_soon: 'Coming soon',
  layers_no_currents_here: 'No current stations in view',
  layers_no_radar_here: 'No radar coverage in view',
  // The compass button's accessible name. {{point}} is a 16-point direction
  // (SSW) and {{deg}} the exact bearing — the face rounds to 8 points, this
  // does not. English placeholder in the non-English catalogs, awaiting
  // translation; catalog parity is enforced by scripts/check-locale-keys.mjs.
  follow_my_direction: 'Meiner Ausrichtung folgen',
  compass_faces: 'Map faces {{point}} · {{deg}}°, tap for north-up',
  ww_row_no_data: '{{row}}: keine Daten hier',
  ww_row_no_forecast_after: '{{row}}: keine Vorhersage nach {{when}}',
  ww_row_no_forecast: '{{row}}: keine Vorhersage so weit voraus',
  ww_unavailable: 'Wetterdaten nicht verfügbar',
  explore_show_player: 'Zeitleiste anzeigen',
  explore_hide_player: 'Zeitleiste ausblenden',

  // --- Routenplanung auf /explore ---
  // Beschreiben, nie raten; nie „sicher". Der Haftungsausschluss des Dienstes
  // wird wörtlich aus der Antwort gezeigt; route_disclaimer ist nur der Fallback.
  route_plan: 'Route planen',
  route_leave: 'Routenplanung verlassen',
  route_title: 'Route',
  route_prompt_start: 'Tippen Sie auf das Wasser, wo Sie starten.',
  route_prompt_start_desktop: 'Klicken Sie auf das Wasser, wo Sie starten, dann auf Ihr Ziel.',
  route_prompt_end: 'Start gesetzt. Tippen Sie jetzt auf Ihr Ziel.',
  route_prompt_end_desktop: 'Start gesetzt. Klicken Sie jetzt auf Ihr Ziel.',
  route_drag_hint: 'Die Pins lassen sich verschieben.',
  route_clear: 'Löschen',
  route_swap: 'Start und Ziel tauschen',
  route_share: 'Link kopieren',
  route_copied: 'Link kopiert',
  route_start: 'Start',
  route_destination: 'Ziel',
  route_near: 'bei {{name}}',
  route_loading: 'Route wird berechnet…',
  route_loading_sub: 'Meist ein, zwei Sekunden. Manche Gebiete brauchen bis zu 30 Sekunden.',
  route_loading_slow: 'Noch in Arbeit…',
  route_loading_slow_sub: 'Dieses Gebiet dauert länger als üblich.',
  route_summary_time: '{{duration}} bei {{speed}}',
  route_planning_speed: 'Planungsgeschwindigkeit',
  route_shoalest: 'Flachste Stelle der Route',
  route_planning_draft: 'Planungstiefgang',
  route_change: 'ändern',
  route_draft_title: 'Planungstiefgang',
  route_draft_help:
    'Die Tiefe, für die die Route geplant wird, nicht der Tiefgang Ihres Boots. Tiefer findet weniger Wege, flacher mehr.',
  route_datum: 'Tiefen auf Kartennull (MLLW), ohne Gezeit.',
  route_unassured_note:
    'Orange Abschnitte queren Wasser, das Karte und Vermessung unter {{draft}} nicht auflösen.',
  route_row_start: 'Start {{label}}',
  route_row_heading: 'Kurs {{course}}° ({{point}})',
  route_row_end: 'Ankunft {{label}}',
  route_row_end_sub: 'Ende der Route',
  route_turn_left: 'Links auf {{course}}° drehen',
  route_turn_right: 'Rechts auf {{course}}° drehen',
  route_bear_left: 'Leicht links auf {{course}}°',
  route_bear_right: 'Leicht rechts auf {{course}}°',
  route_then: '{{first}}, dann {{second}}',
  route_keep_mark: 'Passieren Sie {{mark}} {{hand}}',
  route_leave_channel: 'Fahrwasser verlassen ({{mark}})',
  route_on_your: '{{hand}} ({{side}})',
  route_hand_left: 'links',
  route_hand_right: 'rechts',
  route_side_port: 'Backbord',
  route_side_starboard: 'Steuerbord',
  route_mark_buoy: '{{color}}e Tonne {{num}}',
  route_mark_light: '{{color}}es Feuer {{num}}',
  route_mark_daybeacon: '{{color}}e Bake {{num}}',
  route_mark_lighted: '{{mark}} (befeuert)',
  route_red: 'rot',
  route_green: 'grün',
  route_follow: '{{name}} folgen',
  route_follow_two: '{{first}}, dann {{second}} folgen',
  route_follow_channel: 'Fahrwasser {{name}}',
  route_follow_named: '{{name}}',
  route_follow_unnamed: 'dem betonnten Fahrwasser',
  route_follow_marks: '{{count}} Seezeichen',
  route_greens_on: 'Grün {{hand}}',
  route_reds_on: 'Rot {{hand}}',
  route_show_marks: 'Seezeichen anzeigen',
  route_hide_marks: 'Seezeichen ausblenden',
  route_why: 'Warum wird hier gedreht?',
  route_turn_reason: 'Dreht hier, weil {{reason}}',
  route_lights: 'Feuer in Sicht: {{lights}}',
  route_stretch_unassured: 'Tiefe unter {{draft}} nicht aufgelöst',
  route_stretch_rocky: 'zwischen kartierten Felsen',
  route_stretch_canal: 'Kanal: Schleusenbetrieb, Tore und Brückendurchfahrtshöhe nicht modelliert',
  route_step_of: 'Schritt {{n}} von {{total}}',
  route_all_steps: 'Alle Schritte',
  route_prev_step: 'Vorheriger Schritt',
  route_next_step: 'Nächster Schritt',
  route_minutes: '{{n}} Min.',
  route_hours: '{{h}} Std.',
  route_hours_minutes: '{{h}} Std. {{m}} Min.',
  route_err_on_land_origin: 'Ihr Start liegt auf kartiertem Land',
  route_err_on_land_destination: 'Ihr Ziel liegt auf kartiertem Land',
  route_err_on_land_origin_sub:
    'Ziehen Sie den Start-Pin ins Wasser. Marsch, Strand oder Steg gelten in der Karte als Land.',
  route_err_on_land_destination_sub:
    'Ziehen Sie den Ziel-Pin ins Wasser. Marsch, Strand oder Steg gelten in der Karte als Land.',
  route_err_no_route: 'Keine Route bei {{draft}} Planungstiefgang',
  route_err_no_route_sub:
    'Irgendwo zwischen den beiden Punkten ist die Karte flacher als {{draft}}. Ein geringerer Planungstiefgang findet vielleicht einen Weg.',
  route_err_no_snap: 'Kein kartiertes Wasser nahe einem der Punkte',
  route_err_no_snap_sub: 'Setzen Sie die Pins näher an offenes Wasser.',
  route_err_outside: 'Die Routenplanung deckt vorerst US-Gewässer ab',
  route_err_outside_sub:
    'Routen beruhen auf NOAA-Seekarten, daher müssen beide Punkte in US-Gewässern liegen. Weitere Küsten folgen.',
  route_err_timeout: 'Der Routendienst hat zu lange gebraucht',
  route_err_timeout_sub:
    'Manche Gebiete brauchen bis zu 30 Sekunden, und bei diesem ist die Zeit abgelaufen.',
  route_err_unavailable: 'Die Routenplanung ist gerade nicht verfügbar',
  route_err_unavailable_sub: 'Versuchen Sie es gleich noch einmal.',
  route_err_busy: 'Zu viele Routenanfragen',
  route_err_busy_sub: 'Warten Sie eine Minute und versuchen Sie es erneut.',
  route_try_again: 'Erneut versuchen',
  route_disclaimer:
    'Nicht zur Navigation. Diese Route folgt dem betonnten Fahrwasser, wie in der Karte verzeichnet; sie ist keine Aussage, dass das Wasser sicher ist.',
  route_promo_title: 'Folgen Sie dieser Route in der App mit dem Go-Modus',
  route_promo_body:
    'Der Go-Modus zeigt Ihr Boot auf der Karte, mit der Entfernung zum nächsten Seezeichen oder zur nächsten Wende, der Tiefe unter Ihnen sowie Gezeit und Strömung der nächstgelegenen Station. In Tides Near Me für iPhone und Android, mit Abo.',
}
